// Actions
export const PUSH_NOTIFICATION = 'NOTIFICATION/PUSH_NOTIFICATION';
export const DISMISS_NOTIFICATION = 'NOTIFICATION/DISMISS_NOTIFICATION';
export const DANGER = 'danger';
export const ATTENTION = 'attention';

/*** Action Creators ***/
export const pushDangerNotification = ({ title, messages }) => ({
  type: PUSH_NOTIFICATION,
  category: DANGER,
  title,
  messages: messages instanceof Array ? messages : [messages]
});

export const pushAttentionNotification = ({ title, messages }) => ({
  type: PUSH_NOTIFICATION,
  category: ATTENTION,
  title,
  messages: messages instanceof Array ? messages : [messages]
});

export const dismissNotification = (index) => ({
  type: DISMISS_NOTIFICATION,
  index: index
});

/*** Reducer ***/
export const DEFAULT_STATE = {
  notifications: []
};

export default function notificationReducer(
  state = DEFAULT_STATE,
  { type, index, category, title, messages } = {}
) {
  switch (type) {
    case PUSH_NOTIFICATION: {
      const duplicateErrorExists = () => {
        const newMessage = JSON.stringify(messages).toLowerCase();
        for (const item of state.notifications) {
          const storedMessage = JSON.stringify(item.messages).toLowerCase();
          if (storedMessage === newMessage) {
            return true;
          }
        }
        return false;
      };

      return {
        ...state,
        notifications: duplicateErrorExists()
          ? [...state.notifications]
          : [{ category, title, messages }, ...state.notifications]
      };
    }
    case DISMISS_NOTIFICATION:
      return {
        ...state,
        notifications: [
          ...state.notifications.slice(0, index),
          ...state.notifications.slice(index + 1)
        ]
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/notification/notification.js